import React, { useContext, useState, useEffect } from "react";
import { ListItemSecondaryAction, Grid } from "@mui/material";
import MainCard from "ui-component/cards/MainCard";
import SubCard from "ui-component/cards/SubCard";
import { gridSpacing } from "store/constant";
import TextFieldInput from "components/input/TextFieldInput";
import { DatoSolicitudCredito, Plazos } from "utils/types";
import endpoints from "utils/services/EndPoints";
import Api from "utils/services/Api";
import Steeper from "components/Steps/Steeper";
import { stepsSolicitudCredito } from "utils/Constantes";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import InputFieldSelectSimple from "components/inputSelect/InputFieldSelectSimple";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { codigoAgencia } from "utils/Constantes";
import { codigoEstadoOperacion } from "utils/Constantes";
import Table from "components/Tabla/Table";
import { getCodigoUsuario, getCodigoIfip } from "utils/Common";
import FeatherIcon from "feather-icons-react";
import {
  listaPlazosUtil,
  procesoOK,
  procesoWarning,
  procesoError,
  listaTipoCuota,
} from "utils/Constantes";
import { isObjEmpty } from "utils/utils";
import moment from "moment";
import { usePersona } from "../../context/persona";
const SolicitudCredito = () => {
  const { infoPersona, setInfoPersona } = usePersona();
  const navigate = useNavigate();
  // HOOKS DE ESTADO NOTIFICACIONES
  const [openNotificacion, setOpenNotificacion] = useState(false);
  const [visualizaMensaje, setVisualizaMensaje] = useState("");
  const [colorNotificacion, setColorNotificacion] = useState("");

  // HOOKS COMUN
  const [activaSeccionConsulta, setActivaSeccionConsulta] = useState(false);
  const [disabledGuardar, setDisabledGuardar] = useState(false);
  const [disabledSiguiente, setDisabledSiguiente] = useState(false);
  const [numeriIdentificacion, setNumeriIdentificacion] = useState("");
  const [datosSolicitudCredito, setDatosSolicitudCredito] = useState(
    DatoSolicitudCredito()
  );

  const [listaTipoPeriodicidad, setListaTipoPeriodicidad] = useState([]);
  const [openPeriodicidad, setOpenPeriodicidad] = useState(false);
  const [objPeriodicidad, setObjPeriodicidad] = useState({});

  const [listaProductoTasa, setListaProductoTasa] = useState([]);
  const [openProductoTasa, setOpenProductoTasa] = useState(false);
  const [objProductoTasa, setObjProductoTasa] = useState({});
  const [objSoloTasa, setObjSoloTasa] = useState(0);

  const [listaCuentasExternas, setListaCuentasExternas] = useState([]);
  const [openCuentaExterna, setOpenCuentaExterna] = useState(false);
  const [objCuentasExternas, setObjCuentasExternas] = useState({});

  const [listaTipoCuentas, setListaTipoCuentas] = useState([]);
  const [openTipoCuenta, setOpenTipoCuenta] = useState(false);
  const [objTipoCuenta, setObjTipoCuenta] = useState({});

  const [listaDestinoCredito, setListaDestinoCredito] = useState([]);
  const [openDestinoCredito, setOpenDestinoCredito] = useState(false);
  const [objDestinoCredito, setObjDestinoCredito] = useState({});

  const [listaActividadEconomica, setListaActividadEconomica] = useState([]);
  const [openActividadEconomica, setOpenActividadEconomica] = useState(false);
  const [objActividadEconomica, setObjActividadEconomica] = useState({});

  const [openPlazos, setOpenPlazos] = useState(false);
  const [objPlazos, setObjPlazos] = useState(Plazos());

  // Para la fechas de pago
  const [objFechaPago, setObjFechaPago] = useState(moment().add(30, "day"));

  const [listaTipoAcreditacion, setListaTipoAcreditacion] = useState([]);
  const [openTipoAcreditacion, setOpenTipoAcreditacion] = useState(false);
  const [objTipoAcreditacion, setObjTipoAcreditacion] = useState({});

  // const [listaTipoCuota, setListaTipoCuota] = useState([])
  const [openTipoCuota, setOpenTipoCuota] = useState(false);
  const [objTipoCuota, setObjTipoCuota] = useState({});
  const [creditos, setCreditos] = useState([]);

  // CONTROL STATE
  const [existeSocio, setExisteSocio] = useState(false);
  const [isNuevo, setIsNuevo] = useState(false);
  const [muestraTabla, setMuestraTabla] = useState(false);
  const [solicitudCreditoOK, setSolicitudCreditoOK] = useState(false);

  // ACCESOS STEPS
  const [stepsActive, setStepsActive] = useState(0);
  const [skipped, setSkipped] = React.useState(new Set());

  // FUNCIONES
  useEffect(() => {
    if (infoPersona.codigo === "" || infoPersona.row === undefined) {
      init();
      getCodigoUsuario();
      // INVOCA SERVICIOS PARA SOLICITUD DE CREDITO
    } else {
      setExisteSocio(true);
      setDatosSolicitudCredito(infoPersona.row);
      setSolicitudCreditoOK(infoPersona.row?.existeSolicitudCredito);
      setObjPeriodicidad(infoPersona.row.periocidadMs);
      setObjProductoTasa(infoPersona.row.productoTasaMs);
      setObjDestinoCredito(infoPersona.row.destinoOpeCreMs);
      setObjCuentasExternas(infoPersona.row.ifipExternaMs);
      setObjTipoCuenta(infoPersona.row.tipoCuentaExternaMs);
      setObjActividadEconomica(infoPersona.row.actividadEconomicaMs);
      setObjTipoAcreditacion(infoPersona.row.tipoAcreditacionMs);
      // Asigna tipo de cuota
      verificaTipoCuenta(infoPersona.row.tipoCuota);
      // Sube datos del cotexto
      setInfoPersona({ row: infoPersona.row, codigo: infoPersona.row.codigo, codigoPersona: infoPersona.row.ingresoPersonaMs.personaMs.codigo, valorSolicitado: infoPersona.row.valorSolicitado, primeraCuota: 1 });
      setActivaSeccionConsulta(false);
      setDisabledGuardar(false);
      setDisabledSiguiente(false);
      generarNotificacion(true, "Solicitud de crédito ya registrada.", 1);
    }
    handleSearchTipoPeriodicidad();
    handleSearchDestinoCredito();
    handleSearchProductoTasa();
    // INVOCA SERVICIOS PARA CUENTAS DESTINO DE CREDITO
    handleSearchCuentaExterna();
    handleSearchTipoCuenta();
    handleSearchActividadEconomica();
    handleSearchTipoAcreditacion();
  }, []);
  // FUNCIONES NOTIFICACION
  const generarNotificacion = (abrir, mensaje, color) => {
    setOpenNotificacion(abrir);
    setVisualizaMensaje(mensaje);
    if (color === 1) {
      setColorNotificacion(procesoOK);
    }
    if (color === 2) {
      setColorNotificacion(procesoWarning);
    }
    if (color === 3) {
      setColorNotificacion(procesoError);
    }
  };
  const cerrarNotificacion = () => {
    setOpenNotificacion(false);
  };
  // FUNCIONES COMUN
  const init = () => {
    setActivaSeccionConsulta(true);
    setStepsActive(0);
    setObjTipoAcreditacion({});
    setObjActividadEconomica({});
    setMuestraTabla(false);
  };
  const handleSearchSocio = () => {
    try {
      (async () => {
        Api(
          endpoints.verificaSolicitudCreditoIdentificacion +
          "/" +
          numeriIdentificacion,
          "GET",
          null
        )
          .then((response) => {
            if (response.length === 0) {
              setDisabledGuardar(false);
              setDisabledSiguiente(false);
              generarNotificacion(
                true,
                "No existe el socio de acuerdo al numero de identificacion ingresado",
                2
              );
              return;
            }
            setCreditos(response);
            setIsNuevo(true);
            setMuestraTabla(true);

          })
          .catch((error) => {
            generarNotificacion(true, error.message, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.message, 3);
    }
  };
  const verificaTipoCuenta = (nomenclaturaTipoCuota) => {
    listaTipoCuota.forEach((element) => {
      if (element.nomenclatura === nomenclaturaTipoCuota) {
        setObjTipoCuota(element);
      }
    });
  };
  // SERVICIO PARA CONSULTAR DATOS PARA SOLICITUD DE CREDITO
  const handleSearchTipoPeriodicidad = () => {
    try {
      (async () => {
        Api(endpoints.obtieneTipoPeriodicidad, "GET", null)
          .then((response) => {
            setListaTipoPeriodicidad(response);
          })
          .catch((error) => {
            generarNotificacion(true, error.mensaje, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.mensaje, 3);
    }
  };
  const handleSearchDestinoCredito = () => {
    try {
      (async () => {
        Api(endpoints.listDestinoOpeCredito, "GET", null)
          .then((response) => {
            setListaDestinoCredito(response);
          })
          .catch((error) => {
            generarNotificacion(true, error.mensaje, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.mensaje, 3);
    }
  };
  const handleSearchProductoTasa = () => {
    try {
      (async () => {
        Api(endpoints.listProductoTasa, "GET", null)
          .then((response) => {
            setListaProductoTasa(response);
          })
          .catch((error) => {
            generarNotificacion(true, error.mensaje, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.mensaje, 3);
    }
  };

  // SERVICIO PARA CUENTAS DESTINO DEL DESEMBOLSE DEL CREDITO
  const handleSearchCuentaExterna = () => {
    try {
      (async () => {
        Api(endpoints.listCuentasExternas, "GET", null)
          .then((response) => {
            setListaCuentasExternas(response);
          })
          .catch((error) => {
            generarNotificacion(true, error.mensaje, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.mensaje, 3);
    }
  };
  const handleSearchTipoCuenta = () => {
    try {
      // const data = await Api(endpoints.listPlazos, "GET", null)
      (async () => {
        Api(endpoints.listTipoCuentas, "GET", null)
          .then((response) => {
            setListaTipoCuentas(response);
          })
          .catch((error) => {
            generarNotificacion(true, error.mensaje, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.mensaje, 3);
    }
  };
  const handleSearchActividadEconomica = () => {
    try {
      // const data = await Api(endpoints.listPlazos, "GET", null)
      (async () => {
        Api(endpoints.listaActividadesEconomicas, "GET", null)
          .then((response) => {
            setListaActividadEconomica(response);
          })
          .catch((error) => {
            generarNotificacion(true, error.mensaje, 3);
          });
      })();
    } catch (error) {
    }
  };

  const handleSearchTipoAcreditacion = () => {
    try {
      (async () => {
        Api(endpoints.listTipoAcreditacion, "GET", null)
          .then((response) => {
            setListaTipoAcreditacion(response);
          })
          .catch((error) => {
            generarNotificacion(true, error.mensaje, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.mensaje, 3);
    }
  };

  // FUNCION PARA GUARDAR INFORMACION
  const handleSave = () => {
    let codigo = 1;
    if (isObjEmpty(objActividadEconomica)) {
      generarNotificacion(
        true,
        "Seleccione una actividad económica valida.",
        3
      );
      return;
    }
    if (
      datosSolicitudCredito.valorSolicitado === null ||
      datosSolicitudCredito.valorSolicitado === 0
    ) {
      generarNotificacion(true, "Ingrese el monto a solicitar.", 3);
      return;
    }
    if (isObjEmpty(objPlazos)) {
      generarNotificacion(true, "Seleccione un plazo valido.", 3);
      return;
    }
    if (isObjEmpty(objPeriodicidad)) {
      generarNotificacion(true, "Seleccione una periodicidad valida.", 3);
      return;
    }
    if (isObjEmpty(objProductoTasa)) {
      generarNotificacion(true, "Seleccione una producto valido.", 3);
      return;
    }
    if (isObjEmpty(objDestinoCredito)) {
      generarNotificacion(true, "Seleccione un destino de crédito valido.", 3);
      return;
    }
    if (isObjEmpty(objTipoCuota)) {
      generarNotificacion(true, "Seleccione un tipo de cuota valido.", 3);
      return;
    }

    const fechaActual = moment();
    const diff = objFechaPago.diff(fechaActual, 'days');
    if (diff < 19 || diff > 39) {
      generarNotificacion(true, "La fecha de pago debe tener mínimo 20 y máximo 40 días de diferencia a la fecha actual.", 3);
      return;
    }

    if (isObjEmpty(objCuentasExternas)) {
      generarNotificacion(true, "Seleccione una cuenta externa valido.", 3);
      return;
    }
    if (isObjEmpty(objProductoTasa)) {
      generarNotificacion(true, "Seleccione una producto valido.", 3);
      return;
    }
    if (isObjEmpty(objTipoAcreditacion)) {
      generarNotificacion(
        true,
        "Seleccione un tipo de acreditación valida.",
        3
      );
      return;
    }
    if (
      datosSolicitudCredito.cuentaDestino === undefined ||
      datosSolicitudCredito.cuentaDestino === 0
    ) {
      generarNotificacion(
        true,
        "Ingrese el número de cuenta destino valido.",
        3
      );
      return;
    }

    // ARMA PARAMETROS PARA REGISTRO EN BASE DE DATOS
    const parametros = {
      codigo: datosSolicitudCredito.codigo,
      ingreMs: {
        codigo: getCodigoIfip(),
      },
      agenciaMs: {
        codigo: codigoAgencia,
      },
      ingresoPersonaMs: {
        codigo: datosSolicitudCredito.ingresoPersonaMs.codigo, // Corregir poner codigo de socio no el de la persona
      },
      productoTasaMs: {
        codigo: objProductoTasa.codigo,
      },
      periocidadMs: {
        codigo: objPeriodicidad.codigo,
      },
      estadoOpeCreMs: {
        codigo: codigoEstadoOperacion,
      },
      actividadEconomicaMs: {
        codigo: objActividadEconomica.codigo,
      },
      destinoOpeCreMs: {
        codigo: objDestinoCredito.codigo,
      },
      valorTasa: objProductoTasa.valorTasa,
      numeroCuota: objPlazos.plazo,
      diasGracia: 0,
      valorSolicitado: datosSolicitudCredito.valorSolicitado,
      fechaRegistra: null,
      fechaPago:objFechaPago,
      codigoUsuarioRegistra: getCodigoUsuario(),
      observaciones: "Ingreso solicitud credito",
      cuentaDestino: datosSolicitudCredito.cuentaDestino,
      tipoCuota: objTipoCuota.nomenclatura,
      tipoAcreditacionMs: {
        codigo: objTipoAcreditacion.codigo,
      },
      ifipExternaMs: {
        codigo: objCuentasExternas.codigo,
      },
      tipoCuentaExternaMs: {
        codigo: objTipoCuenta.codigo,
      },
    };
    if (codigo === 1) {
      (async () => {
        Api(endpoints.saveCredito, "POST", parametros)
          .then((response) => {
            // Retorno datos Operacion Crediticia
            if (response.existeSolicitudCredito) {
              // Sube datos del cotexto
              setInfoPersona({ row: response, codigo: response.codigo, codigoPersona: datosSolicitudCredito.ingresoPersonaMs.codigo, valorSolicitado: datosSolicitudCredito.valorSolicitado });
              setDatosSolicitudCredito(response);
              setSolicitudCreditoOK(response.existeSolicitudCredito);
              setObjPeriodicidad(response.periocidadMs);
              setObjProductoTasa(response.productoTasaMs);
              //setObjDestinoCredito(response.destinoOpeCreMs)
              //   setObjCuentasExternas(response.ifipExternaMs)
              setObjTipoCuenta(response.tipoCuentaExternaMs);
              setDisabledGuardar(true);
              setDisabledSiguiente(false);
              generarNotificacion(true, "Registro exitoso.", 1);
            }
          })
          .catch((error) => {
            generarNotificacion(true, error.mensaje, 3);
            return;
          });
      })();
    }
  };
  const onChangeIdentificacion = (identificacion) => {
    if (identificacion === undefined) return;
    setNumeriIdentificacion(identificacion);
    
    console.log(identificacion)
  };
  // CAMBIOS SELECT
  const onchangePeriodicidad = (event, value) => {
    if (value === null) return;
    setObjPeriodicidad(value);
  };
  const onchangeProductoTasa = (event, value) => {
    setObjProductoTasa({});
    if (value === null) return;
    setObjProductoTasa(value);
    setObjSoloTasa(value.valorTasa);
  };
  const onchangeDestinoCredito = (event, value) => {
    if (value === null) return;
    setObjDestinoCredito(value);
  };
  const onchangeTipoCuota = (event, value) => {
    if (value === null) return;
    setObjTipoCuota(value);
  };
  const onchangeEntidadFinanciera = (event, value) => {
    if (value === null) return;
    setObjCuentasExternas(value);
  };
  const onchangeTipoCuenta = (event, value) => {
    if (value === null) return;
    setObjTipoCuenta(value);
  };
  const onchangeActividadEconomica = (event, value) => {
    if (value === null) return;
    setObjActividadEconomica(value);
  };

  const onchangePlazo = (event, value) => {
    if (value === null) return;
    setObjPlazos(value);
  };

  const onchangeTipoAcreditacion = (event, value) => {
    if (value === null) return;
    setObjTipoAcreditacion(value);
  };

  // CAMBIO DE STEEPER
  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  const nextStep = () => {
    navigate("/home/garantes");
  };
  const table = () => {
    navigate("/home/tablaAmortizacion");
  };
  const backStep = () => {
    init();
    setActivaSeccionConsulta(true);
    setExisteSocio(false);
    setDisabledGuardar(true);
    setDisabledSiguiente(true);
  };
  const handleReset = () => {
    let newSkipped = skipped;
    if (isStepSkipped(stepsActive)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(stepsActive);
    }

    setStepsActive((prevActiveStep) => prevActiveStep - 1);
    setSkipped(newSkipped);
  };
  const handleNuevoCreditoSocio = () => {
    try {
      (async () => {
        Api(
          endpoints.operacionCrediticiaNueva +
          "/" +
          numeriIdentificacion,
          "GET",
          null
        )
          .then((response) => {
            setDatosSolicitudCredito(response);
            setExisteSocio(true);
            setMuestraTabla(false);
            setSolicitudCreditoOK(false);
            setActivaSeccionConsulta(false);
            setDisabledGuardar(false);
            setDisabledSiguiente(true);
            setObjProductoTasa({});
            setObjPlazos({});
            setObjPeriodicidad({});
            setObjDestinoCredito({});
            setObjSoloTasa(0);
            setObjTipoCuota({});
            generarNotificacion(
              true,
              "Va a reigstrar un crédito para este socio.",
              2
            );
          })
          .catch((error) => {
            generarNotificacion(true, error.message, 3);
          });
      })();
    } catch (error) {
      generarNotificacion(true, error.message, 3);
    }
  };

  const onRowSelect = (row) => {
    setExisteSocio(true);
    setDatosSolicitudCredito(row);
    if (row.existeSolicitudCredito === true) {
      setSolicitudCreditoOK(row.existeSolicitudCredito);
      setObjPeriodicidad(row.periocidadMs);
      setObjProductoTasa(row.productoTasaMs);
      setObjPlazos({ codigo: 1, plazo: row.numeroCuota });
      setObjSoloTasa(row.valorTasa);
      setObjDestinoCredito(row.destinoOpeCreMs);
      setObjCuentasExternas(row.ifipExternaMs);
      setObjTipoCuenta(row.tipoCuentaExternaMs);
      setObjActividadEconomica({ codigo: row.actividadEconomicaMs.codigo, descripcion: row.actividadEconomicaMs.descripcion_actividad });
      setObjTipoAcreditacion(row.tipoAcreditacionMs);
      // Fecha de pago del credito
      if (row.fechaPago) {
        setObjFechaPago(row.fechaPago);
      }
      // Asigna tipo de cuota
      verificaTipoCuenta(row.tipoCuota);
      // Sube datos del cotexto
      setInfoPersona({ row: row, codigo: row.codigo, codigoPersona: row.ingresoPersonaMs.personaMs.codigo, valorSolicitado: row.valorSolicitado, primeraCuota: 1 });
      setActivaSeccionConsulta(false);
      setDisabledGuardar(false);
      setDisabledSiguiente(false);
      generarNotificacion(true, "Solicitud de crédito ya registrada.", 1);
    } else {
      setSolicitudCreditoOK(false);
      setActivaSeccionConsulta(false);
      setDisabledGuardar(false);
      setDisabledSiguiente(true);
      generarNotificacion(
        true,
        "Va a reigstrar un crédito para este socio.",
        2
      );
    }
  };

  const columns = [
    {
      title: "Identificacion",
      field: "ingresoPersonaMs.personaMs.numeroIdentificacion",
      editable: false,
    },
    {
      title: "Socio",
      field: "ingresoPersonaMs.personaMs.nombres",
      editable: false,
    },
    {
      title: "Crédito",
      field: "codigo",
      editable: false,
    },
    {
      title: "Monto",
      field: "valorSolicitado",
      editable: false,
    },
    {
      title: "Estado",
      field: "estadoOpeCreMs.descripcion",
      editable: false,
    },
  ];
  // VISTA
  const tamanoCaja = 6;
  const varianField = "outlined";
  return (
    <>
      <Steeper steps={stepsSolicitudCredito} activeStep={stepsActive} />
      <MainCard
        title="SOLICITUD DE CRÉDITO"
        open={openNotificacion}
        mensajeVizualizar={visualizaMensaje}
        colorProceso={colorNotificacion}
        handleClose={() => cerrarNotificacion()}
        secondary={
          <ListItemSecondaryAction link="https://next.material-ui.com/system/typography/" />
        }
      >
        <Grid container xs={12} spacing={gridSpacing}>
          <Grid item xs={24}>
            {activaSeccionConsulta && (
              <SubCard
                style={{ alignItems: "center" }}
                title="CONSULTA DATOS DE SOCIO"
              >
                <Grid container xs={12} spacing={1}>
                  <Grid item md={6}>
                    <TextFieldInput
                      label={"Cédula / nombres"}
                      md={tamanoCaja}
                      fullWidth
                      varianField={varianField}
                      value={numeriIdentificacion}
                      onChange={(e) => {
                        const valor = e.target.value;
                        console.log(valor)
                        if (valor.length === 11) {
                          return false;
                        }
                        onChangeIdentificacion(valor);
                      }}
                    />
                  </Grid>
                  {muestraTabla && (<Grid item md={12}>
                    <Table
                      id={"codigo"}
                      title="LISTADO DE CREDITOS / PERSONAS"
                      columns={columns}
                      data={creditos}
                      onRowClick={(evt, selectedRow) =>
                        onRowSelect(selectedRow)
                      }
                    ></Table>
                  </Grid>)}
                </Grid>
              </SubCard>
            )}
            {existeSocio && (
              <>
                <SubCard
                  style={{ alignItems: "center" }}
                  title="DATOS DEL SOCIO SOLICITANTE"
                >
                  <Grid
                    container
                    xs={12}
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                    direction="row"
                    justifyContent="space-around"
                    alignItems="stretch"
                  >
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Identificación"}
                        sm={tamanoCaja}
                        varianField={varianField}
                        fullWidth
                        disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                        value={numeriIdentificacion}
                        onChange={(e) => {
                          const valor = e.target.value;
                          if (valor.length === 11) {
                            return false;
                          }
                          onChangeIdentificacion(valor);
                        }}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Nombres"}
                        sm={tamanoCaja}
                        fullWidth
                        varianField={varianField}
                        disabled={true}
                        value={
                          datosSolicitudCredito.ingresoPersonaMs.personaMs ===
                            null
                            ? ""
                            : datosSolicitudCredito.ingresoPersonaMs.personaMs
                              .nombres
                        }
                      />
                    </Grid>
                  </Grid>
                </SubCard>
              </>
            )}
            {existeSocio && (
              <>
                <SubCard
                  style={{ alignItems: "center" }}
                  title="ACTIVIDAD ECONÓMICA"
                >
                  <Grid container xs={12} spacing={1}>
                    <Grid item xs={12} md={12}>
                      <InputFieldSelectSimple
                        id={"idActividadEconomica"}
                        // md={tamanoCaja}
                        variant={"outlined"}
                        label={"Actividad Económica"}
                        loading={false}
                        fullWidth
                        disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                        open={openActividadEconomica}
                        onOpen={() => {
                          setOpenActividadEconomica(true);
                        }}
                        onClose={() => {
                          setOpenActividadEconomica(false);
                        }}
                        options={listaActividadEconomica}
                        getOptionLabel={(option) =>
                          option.descripcion ? option.descripcion : ""
                        }
                        value={
                          objActividadEconomica || objActividadEconomica.codigo
                        }
                        onChange={onchangeActividadEconomica}
                      />
                    </Grid>
                  </Grid>
                </SubCard>
                <SubCard
                  //style={{ alignItems: "center" }}
                  title="DETALLES DEL CRÉDITO SOLICITANTE"
                >
                  <Grid container xs={12} spacing={1}>
                    <Grid item md={tamanoCaja}>
                      <InputFieldSelectSimple
                        id={"idProductoTasa"}
                        md={tamanoCaja}
                        variant={"outlined"}
                        label={"Producto tasa"}
                        loading={false}
                        disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                        open={openProductoTasa}
                        onOpen={() => {
                          setOpenProductoTasa(true);
                        }}
                        onClose={() => {
                          setOpenProductoTasa(false);
                        }}
                        options={listaProductoTasa}
                        getOptionLabel={(option) =>
                          option.descripcion === undefined
                            ? ""
                            : option.descripcion
                        }
                        value={
                          objProductoTasa ||
                          objProductoTasa.productoTasaMs.codigo
                        }
                        onChange={onchangeProductoTasa}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <InputFieldSelectSimple
                        id={"idPlazos"}
                        md={tamanoCaja}
                        variant={"outlined"}
                        label={"Plazo"}
                        loading={false}
                        disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                        open={openPlazos}
                        onOpen={() => {
                          setOpenPlazos(true);
                        }}
                        onClose={() => {
                          setOpenPlazos(false);
                        }}
                        options={listaPlazosUtil}
                        getOptionLabel={(option) =>
                          option.plazo ? option.plazo + "" : ""
                        }
                        value={objPlazos || objPlazos.codigo}
                        onChange={onchangePlazo}
                      />
                    </Grid>

                    <Grid item md={tamanoCaja}>
                      <InputFieldSelectSimple
                        id={"idPeriodicidad"}
                        //md={tamanoCaja}
                        variant={"outlined"}
                        label={"Periodicidad"}
                        loading={false}
                        open={openPeriodicidad}
                        disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                        onOpen={() => {
                          setOpenPeriodicidad(true);
                        }}
                        onClose={() => {
                          setOpenPeriodicidad(false);
                        }}
                        options={listaTipoPeriodicidad}
                        getOptionLabel={(option) =>
                          option.descripcion === undefined
                            ? ""
                            : option.descripcion
                        }
                        value={objPeriodicidad || objPeriodicidad.codigo}
                        onChange={onchangePeriodicidad}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <InputFieldSelectSimple
                        id={"idDestinoOpeCredito"}
                        md={tamanoCaja}
                        variant={"outlined"}
                        label={"Destino crédito"}
                        loading={false}
                        disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                        open={openDestinoCredito}
                        onOpen={() => {
                          setOpenDestinoCredito(true);
                        }}
                        onClose={() => {
                          setOpenDestinoCredito(false);
                        }}
                        options={listaDestinoCredito}
                        getOptionLabel={(option) =>
                          option.descripcion ? option.descripcion : ""
                        }
                        value={objDestinoCredito || objDestinoCredito.codigo}
                        onChange={onchangeDestinoCredito}
                      />
                    </Grid>

                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Valor solicitado"}
                        md={tamanoCaja}
                        fullWidth
                        varianField={"outlined"}
                        disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                        value={datosSolicitudCredito.valorSolicitado === null ? 0 : datosSolicitudCredito.valorSolicitado}
                        onChange={(e) => {
                          const valor = e.target.value;
                          if (isNaN(valor)) {
                            return false;
                          }
                          setDatosSolicitudCredito((prevState) => {
                            return { ...prevState, valorSolicitado: valor };
                          });
                        }}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Tasa interes"}
                        md={tamanoCaja}
                        fullWidth
                        varianField={varianField}
                        disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                        value={objSoloTasa}
                        onChange={(e) => {
                          const valor = e.target.value;
                          setDatosSolicitudCredito((prevState) => {
                            return { ...prevState, valorTasa: valor };
                          });
                        }}

                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <InputFieldSelectSimple
                        id={"idTipoCuota"}
                        //md={tamanoCaja}
                        variant={"outlined"}
                        label={"Tipo cuota"}
                        loading={false}
                        disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                        open={openTipoCuota}
                        onOpen={() => {
                          setOpenTipoCuota(true);
                        }}
                        onClose={() => {
                          setOpenTipoCuota(false);
                        }}
                        options={listaTipoCuota}
                        getOptionLabel={(option) =>
                          option.descripcion ? option.descripcion : ""
                        }
                        value={objTipoCuota || objTipoCuota.nomenclatura}
                        onChange={onchangeTipoCuota}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <DatePicker
                        label="Fecha de pago"
                        id="fechaPago"
                        value={objFechaPago}
                        inputFormat="DD/MM/YYYY"
                        onChange={(newValue) => {
                          setObjFechaPago(newValue);
                        }}
                        renderInput={(params) => <TextField fullWidth {...params} />}
                        disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                      />
                    </Grid>
                  </Grid>
                </SubCard>
                <SubCard
                  style={{ alignItems: "center" }}
                  title="DATOS DEL TITULAR DE LA CUENTA A LA QUE SE TRANSFIERE EL VALOR SOLICITADO"
                >
                  <Grid
                    container
                    xs={12}
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                    direction="row"
                    justifyContent="space-around"
                    alignItems="stretch"
                  >
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Identificación"}
                        md={tamanoCaja}
                        fullWidth
                        varianField={"outlined"}
                        value={
                          datosSolicitudCredito.ingresoPersonaMs.personaMs ===
                            null
                            ? ""
                            : datosSolicitudCredito.ingresoPersonaMs.personaMs
                              .numeroIdentificacion
                        }
                        disabled={true}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Nombres"}
                        md={tamanoCaja}
                        fullWidth
                        varianField={"outlined"}
                        value={
                          datosSolicitudCredito.ingresoPersonaMs.personaMs ===
                            null
                            ? ""
                            : datosSolicitudCredito.ingresoPersonaMs.personaMs
                              .nombres
                        }
                        disabled={true}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <InputFieldSelectSimple
                        id={"idEntidadFinanciera"}
                        md={tamanoCaja}
                        variant={"outlined"}
                        label={"Entidad financiera"}
                        loading={false}
                        open={openCuentaExterna}
                        onOpen={() => {
                          setOpenCuentaExterna(true);
                        }}
                        onClose={() => {
                          setOpenCuentaExterna(false);
                        }}
                        options={listaCuentasExternas}
                        getOptionLabel={(option) =>
                          option.descripcion ? option.descripcion : ""
                        }
                        value={objCuentasExternas || 1}
                        onChange={onchangeEntidadFinanciera}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <InputFieldSelectSimple
                        id={"idTipoCuenta"}
                        md={tamanoCaja}
                        variant={"outlined"}
                        label={"Tipo cuenta"}
                        loading={false}
                        open={openTipoCuenta}
                        disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                        onOpen={() => {
                          setOpenTipoCuenta(true);
                        }}
                        onClose={() => {
                          setOpenTipoCuenta(false);
                        }}
                        options={listaTipoCuentas}
                        getOptionLabel={(option) =>
                          option.descripcion  ? option.descripcion : ""
                        }
                        value={objTipoCuenta || 1}
                        onChange={onchangeTipoCuenta}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <TextFieldInput
                        label={"Número cuenta"}
                        md={tamanoCaja}
                        fullWidth
                        varianField={"outlined"}
                        value={datosSolicitudCredito.cuentaDestino}
                        disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                        onChange={(e) => {
                          const valor = e.target.value;
                          if (isNaN(valor)) {
                            return false;
                          }
                          setDatosSolicitudCredito((prevState) => {
                            return { ...prevState, cuentaDestino: valor };
                          });
                        }}
                      />
                    </Grid>
                    <Grid item md={tamanoCaja}>
                      <>
                        <br />
                        <InputFieldSelectSimple
                          id={"idTipoAcreditacion"}
                          md={tamanoCaja}
                          fullWidth
                          variant={"outlined"}
                          label={"Tipo Acreditación"}
                          loading={false}
                          open={openTipoAcreditacion}
                          disabled={datosSolicitudCredito.estadoOpeCreMs !== null && datosSolicitudCredito.estadoOpeCreMs.estado === "A" ? true : false}
                          onOpen={() => {
                            setOpenTipoAcreditacion(true);
                          }}
                          onClose={() => {
                            setOpenTipoAcreditacion(false);
                          }}
                          options={listaTipoAcreditacion}
                          getOptionLabel={(option) =>
                            option.descripcion ? option.descripcion : ""
                          }
                          value={
                            objTipoAcreditacion || objTipoAcreditacion.codigo
                          }
                          onChange={onchangeTipoAcreditacion}
                        />
                      </>
                    </Grid>
                  </Grid>
                </SubCard>
              </>
            )}
          </Grid>
        </Grid>
        <br />
        <div className="steps-action">
          {activaSeccionConsulta && (
            <>
              <Button
                type="primary"
                block
                htmlType="submit"
                loading={true}
                onClick={handleSearchSocio}
              >
                <FeatherIcon icon="search" size={16} /> &nbsp; Consutar
              </Button>
              <Button
                type="primary"
                block
                htmlType="submit"
                loading={true}
                onClick={handleNuevoCreditoSocio}
                disabled={!isNuevo}
              >
                <FeatherIcon icon="plus" size={16} /> &nbsp; Nuevo
              </Button>
            </>
          )}
          {!activaSeccionConsulta && (
            <Button
              type="primary"
              block
              htmlType="submit"
              loading={true}
              onClick={handleSave}
              disabled={disabledGuardar}
            >
              <FeatherIcon icon="save" size={16} /> &nbsp; Guardar
            </Button>
          )}
          {solicitudCreditoOK && (
            <>
              <Button
                type="primary"
                block
                htmlType="submit"
                loading={true}
                onClick={nextStep}
                disabled={disabledSiguiente}
              >
                <FeatherIcon icon="chevrons-right" size={16} /> &nbsp; Siguiente
              </Button>

              <Button
                type="primary"
                block
                htmlType="submit"
                loading={true}
                onClick={backStep}
                disabled={disabledSiguiente}
              >
                <FeatherIcon icon="x-circle" size={16} /> &nbsp; Cancelar
              </Button>
              <Button
                type="primary"
                block
                htmlType="submit"
                loading={true}
                onClick={table}
                disabled={disabledSiguiente}
              >
                <FeatherIcon icon="table" size={16} /> &nbsp; Tabla Amortizacion
              </Button>

            </>
          )}
        </div>
      </MainCard>
    </>
  );
};
export default SolicitudCredito;
